import { confirmAlert } from "react-confirm-alert";
import { Trans, useTranslation } from "react-i18next";

export let defaultAlertMessages = {
  TittleError: <Trans>Uyarı</Trans>,
  TittleWarning: <Trans>Uyarı</Trans>,
  TittleSuccess: <Trans>Başarılı</Trans>,
  MessageDetailError: <Trans>please_try_again</Trans>,
  MessageDetailWarning: <Trans>sure_continue</Trans>,
  MessageDetailSuccess: <Trans>successfully_completed</Trans>,
  Ok: <Trans>ok</Trans>,
  Yes: <Trans>yes</Trans>,
  No: <Trans>no</Trans>,
};

export const serviceMessageSuccess = (message) => {
  defaultAlertMessages.MessageDetailSuccess = message;
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmSuccessMessage(onClose, defaultAlertMessages);
    },
  });
};

export const serviceMessageError = (message) => {
  defaultAlertMessages.MessageDetailError = message;
  confirmAlert({
    customUI: ({ onClose }) => {
      return getConfirmErrorMessage(onClose, defaultAlertMessages);
    },
  });
};

export const getConfirmSuccessMessage = (onClose, objMessageInfo) => {
  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="success circle"></div>
        <div className="success-icon  icon">
          <i className="fa fa-check"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleSuccess}</h2>
      <hr></hr>
      <p>{objMessageInfo.MessageDetailSuccess}</p>
      <div className="eConfirmButtons text-center">
        <button className="k-button btn-success w-50" onClick={onClose}>
          {objMessageInfo.Ok}
        </button>
      </div>
    </div>
  );
};

export const getConfirmErrorMessage = (onClose, objMessageInfo) => {
  return (
    <div className="eConfirm">
      <div className="circle-wrapper">
        <div className="error circle"></div>
        <div className="error-icon icon">
          <i className="fa fa-times"></i>
        </div>
      </div>
      <h2 className="text-center">{objMessageInfo.TittleError}</h2>
      <hr></hr>
      <p>{objMessageInfo.MessageDetailError}</p>
      <div className="eConfirmButtons text-center">
        <button className="k-button btn-primary w-50" onClick={onClose}>
          {objMessageInfo.Ok}
        </button>
      </div>
    </div>
  );
};

export const NoMatch = () => {
  const { t } = useTranslation();
  return <p>{t("not_found")}</p>;
};

/**
 *
 * @param {Date} value
 */
export function extractTimeFromDate(value) {
  var hour = value.getHours();
  if (hour < 10) hour = `0${hour}`;
  var minute = value.getMinutes();
  if (minute < 10) minute = `0${minute}`;
  return `${hour}:${minute}:00`;
}
